
import { db } from './firebase';
import { useEffect, useState } from "react";
import Cookies from 'js-cookie';
import { useNavigate } from 'react-router-dom';
import { Route, Routes } from "react-router-dom";
import { appRoutes } from './routes';
//
 
import './App.css';
import Header from './body_roots/header';
import Footer from './body_roots/footer';
import Home from './home_pages/home';
import WhatsAppQueryPopup from './components/WhatsAppQueryPopup';
//Web root
import './web_root/web_app.css';
import { WebRoutes } from './webroutes';
import WebHeader from './web_root/web_header';
import Webidpage from './web_root/webidpage';
import Navbar from './web_root/Navbar';
import Webfooter from './web_root/webfooter';
function App() {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [islogin, setislogin] = useState(false);
  //
  useEffect(() => {
    const fetchUserData = async () => {
      const existingUser = Cookies.get("guid");
      if (existingUser) {
        setislogin(true); 
      } else {
        setislogin(false);
      }
    };
    fetchUserData();
  }, []);
  return (
    <>
    {islogin ? (
      <div className="web_app">
        <WebHeader />
        <div className="app_header_height"></div>
        <Routes> 
          {WebRoutes.map(({ path, element }, i) => (
            <Route key={i} path={path} element={element} />
          ))}
          <Route path="/:id" element={<Webidpage />} />
        </Routes>
        <Webfooter/>
        <Navbar/>

      </div>
    ) : (
      <div className="App">
        <Header />
        <WhatsAppQueryPopup />
        <div className="app_header_height"></div>
        <Routes>
          {appRoutes.map(({ path, element }, i) => (
            <Route key={i} path={path} element={element} />
          ))}
          <Route path="/:id" element={<Home />} />
        </Routes>
        <Footer />
      </div>
    )}
</>
  );
}

export default App;
